import type { ErrorHandling } from "@/lib/error_handling"

const deliveryMethods = {
  error: console.error,
  log: console.log,
  warn: console.warn,
}

export const deliverReport = <Channel extends ErrorHandling.ReportChannel>({
  channel,
  report,
}: {
  channel: Channel
  report: ErrorHandling.Report
}) => {
  return deliveryMethods[channel](...report)
}
